export const allEqual = (arr) => arr.every((val) => val === arr[0]);
